import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import FieldReadView from './FieldReadView';

export default function FieldWithEditable({ title, value, onEdit }) {
  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="space-between"
    >
      <FieldReadView
        title={title}
        value={value}
      />
      {onEdit && (
        <Button
          color="info"
          onClick={onEdit}
          variant="text"
        >
          Edit
        </Button>
      )}
    </Stack>
  );
}

FieldWithEditable.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onEdit: PropTypes.func
};
